import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCheckSvg } from "./IconCheckSvg.mjs";
const IconCheck = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCheckSvg, ...iconProps });
};
export {
  IconCheck
};
